import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchAdditionJob = createAsyncThunk(
  "additional-job",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/additional-job`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data;
    } catch (error) {
      console.error("Error fetching addition job data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch test drive data"
      );
    }
  }
);

export const createAdditionalJob = createAsyncThunk(
  'additional-job/store', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.post(`${API_URL}/additional-job/store`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
          
          return response.data;
      } catch (error) {        
          console.error('Error store additional job:', error);
          return rejectWithValue(error.response?.data || 'Failed to store items');
      }
  }
);

const additionalJobSlice = createSlice({
  name: "additionalJob",
  initialState: {
    additional_job: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdditionJob.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAdditionJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.additional_job = action.payload;
      })
      .addCase(fetchAdditionJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createAdditionalJob.fulfilled, (state, action) => {        
          state.additional_job.push(action.payload.data);
      });
  },
});

export default additionalJobSlice.reducer;
